export const steps = {
  DEFINE: 'Define',
  UPLOAD: 'Upload',
  RESULT: 'Result',
};

export const STEP_SELECT_TYPE = 0;
export const STEP_UPLOAD_AND_VERIFY = 1;
export const STEP_START_IMPORT = 2;
